import React from 'react';
import { useIntl } from "react-intl";
import AtomicButton from "../../../../components/AtomicButton";
import {Loading3QuartersOutlined, LoadingOutlined} from '@ant-design/icons';
import CircularProgress from "../../../../components/CircularProgress";
import CircularProgress2 from "../../../../components/CircularProgress2";
import CircularProgress3 from "../../../../components/CircularProgress3";
import {Spin} from "antd";

const containerStyle = {
  flex: 1,
  backgroundColor: '#fff',
  borderRadius: 4,
  padding: 30,
  // width: 360,
  // minHeight: 220,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
};

const loadingStyle = {
  marginTop: 24,
  marginBottom: 18,
  fontSize: 36,
  color: '#666',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const messageContainerStyle = {
  width: '100%',
  marginBottom: 18,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const headerTitleStyle = {
  fontSize: 20,
  fontWeight: 700,
  color: '#222',
  marginBottom: 8,
  textAlign: 'center',
  display: 'block',
};

const headerSubtitleStyle = {
  fontSize: 16,
  color: '#444',
  textAlign: 'center',
  lineHeight: '22px',
  display: 'block',
};

const footerStyle = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 0,
  marginTop: 'auto',
};

const cancelButtonStyle = {
  padding: '8px 18px',
  backgroundColor: '#4f4f4f',
  borderRadius: 4,
  minWidth: 80,
  minHeight: 40,
  border: 'none',
};

function WaitingRegister({ title, message, onCancel, disabled = false }) {
  const intl = useIntl();

  const handleCancel = () => {
    onCancel?.();
  };

  return (
    <div style={containerStyle}>
      <div style={loadingStyle}>
        <Spin indicator={<Loading3QuartersOutlined style={{ fontSize: 36 }} spin />} />
      </div>
      <div style={messageContainerStyle}>
        <span style={headerTitleStyle}>{title}</span>
        <span style={headerSubtitleStyle}>{message}</span>
      </div>
      <div style={footerStyle}>
        <AtomicButton
          label={intl.formatMessage({ id: 'vlink.common.cancel' })}
          onClick={handleCancel}
          disabled={disabled}
          style={{
            ...cancelButtonStyle,
          }}
        />
      </div>
    </div>
  );
}

export default WaitingRegister;
